/* global axios */
import ApiClient from './ApiClient';

// Settings per-cuenta unificadas de Masifi ("Masifi Inbox"). Resource singular
// (show/update) — data-driven por Masifi::Settings::REGISTRY en el backend.
class MasifiSettingsAPI extends ApiClient {
  constructor() {
    super('masifi/settings', { accountScoped: true });
  }

  // GET → { settings: {...valores}, registry: {...key: {type, default}} }
  // (el `get()` base ya hace axios.get(this.url); lo dejamos por claridad.)
  get() {
    return axios.get(this.url);
  }

  update(settings) {
    return axios.put(this.url, { settings });
  }
}

export default new MasifiSettingsAPI();
